module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b2935b0787ff373cc04c7d2c92de9adb.gif";